import { returnSelf } from '../../run-callback.js';
const stylesheetDom = 'stylesheet';
export const styleHook = {
    resolve: (returnSelf), // prettier-ignore
};
export function injectStyle(path, id) {
    const link = document.createElement('link');
    if (id) {
        link.id = id;
    }
    link.rel = stylesheetDom;
    link.href = path;
    link.setAttribute('data-conv-style', 'true');
    document.head.appendChild(styleHook.resolve(link));
    return link;
}
export function injectStyleInline(css, id) {
    const current = id ? document.getElementById(id) : null;
    const style = current || document.createElement('style');
    style.textContent = css;
    if (!current) {
        if (id) {
            style.id = id;
        }
        document.head.appendChild(style);
    }
    return style;
}
//# sourceMappingURL=style.js.map